"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* ========================================================================
    Application main script
 ========================================================================== */
const uikit_1 = __importDefault(require("uikit"));
const uikit_icons_1 = __importDefault(require("uikit/dist/js/uikit-icons"));
const util_1 = require("~modules/util");
const scroll_1 = require("~modules/scroll");
const navbar_1 = require("~modules/navbar");
const link_to_phone_1 = require("~modules/link-to-phone");
const dropdown_redirect_1 = require("~modules/dropdown-redirect");
const hero_video_1 = require("~modules/hero-video");
const colomn_recommend_slider_1 = require("~modules/colomn-recommend-slider");
// Loads the Icon plugin
uikit_1.default.use(uikit_icons_1.default);
const breakPointMedium = (0, util_1.getCssPropertyValue)("--uk-breakpoint-m");
const breakPointLarge = (0, util_1.getCssPropertyValue)("--uk-breakpoint-l");
window.addEventListener("DOMContentLoaded", util_1.setFillHeight);
window.addEventListener("resize", util_1.setFillHeight);
/*
 * Scroll
 */
window.addEventListener("load", { handleEvent: scroll_1.scroll });
// Scroll from external link
window.addEventListener("load", {
    handleEvent: scroll_1.scrollExternalLink,
});
window.addEventListener("hashchange", { handleEvent: scroll_1.scrollExternalLink });
/*
 * Navbar
 */
// Reset
window.addEventListener("DOMContentLoaded", navbar_1.navbarReset);
window.addEventListener("resize", navbar_1.navbarReset);
// Toggle button
const navToggleElement = document.querySelector(".js-nav-toggle");
if (navToggleElement) {
    navToggleElement.addEventListener("click", { handleEvent: navbar_1.navToggle });
    navToggleElement.addEventListener("keydown", { handleEvent: navbar_1.navToggle });
}
// Dropdown
window.addEventListener("DOMContentLoaded", { handleEvent: navbar_1.navbarDropdown });
window.addEventListener("resize", { handleEvent: navbar_1.navbarDropdown });
/*
 * Link to phone
 */
window.addEventListener("DOMContentLoaded", link_to_phone_1.linkToPhone);
/*
 * Home hero video
 */
window.addEventListener("DOMContentLoaded", hero_video_1.heroVideoSwitch);
window.addEventListener("resize", hero_video_1.heroVideoSwitch);
/*
 * Archive search
 */
window.addEventListener("DOMContentLoaded", dropdown_redirect_1.dropdownRdirect);
/*
 * Column singles recommend
 */
window.addEventListener("DOMContentLoaded", colomn_recommend_slider_1.colomnRecommendSlider);
window.addEventListener("resize", colomn_recommend_slider_1.colomnRecommendSlider);
/*
 * 「既存のお客様用のお問い合わせ」の「その他」に注釈を加える
 */
const jsFormOthersLabel = document.querySelector(".mw_wp_form_input .js-form-radio-items > :nth-child(5) > label");
if (jsFormOthersLabel) {
    window.addEventListener("DOMContentLoaded", () => {
        jsFormOthersLabel.insertAdjacentText("afterend", "　※その他の場合は、簡単に内容をご記入ください。");
    });
}
/*
 * 「既存のお客様用のお問い合わせ」の副項目を移動する
 */
// 新しい求人
const jsFormNewJobs = document.querySelector(".mw_wp_form_input .js-form-radio-items > :nth-child(2)");
const jsFormNewJobsSubItem = document.querySelector(".mw_wp_form_input .js-form-new-jobs-sub-item");
if (jsFormNewJobs && jsFormNewJobsSubItem) {
    window.addEventListener("DOMContentLoaded", () => {
        jsFormNewJobs.insertBefore(jsFormNewJobsSubItem, null);
    });
}
// 掲載中の求人
const jsFormActiveJobs = document.querySelector(".mw_wp_form_input .js-form-radio-items > :nth-child(3)");
const jsFormActiveJobsSubItem = document.querySelector(".mw_wp_form_input .js-form-active-jobs-sub-item");
if (jsFormActiveJobs && jsFormActiveJobsSubItem) {
    window.addEventListener("DOMContentLoaded", () => {
        jsFormActiveJobs.insertBefore(jsFormActiveJobsSubItem, null);
    });
}
// 以前掲載の求人
const jsFormPrevPostedJobs = document.querySelector(".mw_wp_form_input .js-form-radio-items > :nth-child(4)");
const jsFormPrevPostedJobsSubItem = document.querySelector(".mw_wp_form_input .js-form-prev-posted-jobs-sub-item");
if (jsFormPrevPostedJobs && jsFormPrevPostedJobsSubItem) {
    window.addEventListener("DOMContentLoaded", () => {
        jsFormPrevPostedJobs.insertBefore(jsFormPrevPostedJobsSubItem, null);
    });
}
// その他
const jsFormOthers = document.querySelector(".mw_wp_form_input .js-form-radio-items > :nth-child(5)");
const jsFormOthersSubItem = document.querySelector(".mw_wp_form_input .js-form-others-sub-item");
if (jsFormOthers && jsFormOthersSubItem) {
    window.addEventListener("DOMContentLoaded", () => {
        jsFormOthers.insertBefore(jsFormOthersSubItem, null);
    });
}
